import ACTION from '../action_constant';

function addTrips(state = {
  allTrips : []
} , action){
    let allTrips ,tripState;
    switch (action.type) {
      case ACTION.TRIPS.GET_ALL_TRIPS:
        tripState = Object.assign({} ,state);
        allTrips = tripState.allTrips;
        let newAllTrips = [...allTrips,...action.data.trips];
        tripState.allTrips = newAllTrips;
        return Object.assign({},tripState);

      case ACTION.TRIPS.UPDATE_TRIP:
        tripState = Object.assign({},state)
        allTrips = tripState.allTrips;
        for(let i =0;i< allTrips.length; i++)
        {
          if(allTrips[i].tripId == action.data.tripId)
          {
            allTrips[i] = action.data;
            break;
          }
        }
        return Object.assign({},tripState)

      case ACTION.TRIPS.DELETE_TRIP:
          tripState = Object.assign({},state)
          allTrips = tripState.allTrips;
          for(let i =0;i< allTrips.length; i++)
          {
            if(allTrips[i].tripId == action.tripId)
            {
              allTrips.splice(i,1);
              break;
            }
          }
          return Object.assign({},tripState)

       case ACTION.TRIPS.CLEAR_TRIPS:
          return Object.assign({} , state , {allTrips : action.data} )

      default:
      return state ;
    }
}

export default addTrips;



// WEBPACK FOOTER //
// app/add_trips/add_trips_reducer.jsx